module.exports = __webpack_public_path__ + "img/Clear-field-darkmode.7f4a1fc2.svg";